"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDevourStatsQueryToJSON = exports.GetDevourStatsQueryFromJSONTyped = exports.GetDevourStatsQueryFromJSON = void 0;
function GetDevourStatsQueryFromJSON(json) {
    return GetDevourStatsQueryFromJSONTyped(json, false);
}
exports.GetDevourStatsQueryFromJSON = GetDevourStatsQueryFromJSON;
function GetDevourStatsQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'discordMemberId': json['discordMemberId'],
    };
}
exports.GetDevourStatsQueryFromJSONTyped = GetDevourStatsQueryFromJSONTyped;
function GetDevourStatsQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'discordMemberId': value.discordMemberId,
    };
}
exports.GetDevourStatsQueryToJSON = GetDevourStatsQueryToJSON;
